module.exports = __webpack_public_path__ + "media/images/competitions/trophy_icon-ede0372516182598f096e5d2066282db.png";